<template>
    <div data-uk-sticky="sel-target: .uk-navbar-container; cls-active: uk-navbar-sticky">
        <nav class="uk-navbar-container uk-margin uk-light">
            <div class="uk-container">
                <div data-uk-navbar>
                    <div class="nav-overlay uk-navbar-left">
                    
                        <a class="uk-navbar-item uk-logo uk-text-small" href="index.html">
                          {{title}}
                        </a>
                    </div>
                  
                    <div v-if="login" class="nav-overlay uk-navbar-right">
         <div id="user_name">{{user.first_name}} {{user.last_name}} </div>
          <a @click="logout" class="uk-navbar-toggle" data-uk-icon="icon:sign-out; ratio: 1" ref="#"></a>
        <a class="uk-navbar-toggle" uk-search-icon uk-toggle="target: .nav-overlay; animation: uk-animation-fade" href="#"></a>
         
    </div>

    <div class="nav-overlay uk-navbar-left uk-flex-1" hidden>

        <div class="uk-navbar-item uk-width-expand">
            <form class="uk-search uk-search-navbar uk-width-1-1">
                <input class="uk-search-input" v-on:keyup="Searching" type="search" placeholder="Search..." autofocus>
            </form>
        </div>

        <a @click="closeSearch" class="uk-navbar-toggle" uk-close uk-toggle="target: .nav-overlay; animation: uk-animation-fade" href="#"></a>
       
    </div>
                </div>
            </div>
        </nav>
   </div>
</template>

<script>
import ENV from '../config';
export default {
    props:{
        user:{
            type:Object,
        },
        login:{
            type:Boolean
        }
    },
    data(){
      return{
        title:ENV.name,
      }
    },
    methods:{
        Searching(e){
            this.$emit('childToParent',e.target.value)
        },
        closeSearch(){
            this.$emit('childToParent',null)
        },
        logout(){
             var self = this;
            this.$swal({
              title: "Are you sure you want to logout?",
              icon: "warning",
              buttons: true,
              dangerMode: true,
            })
            .then((willLogout) => {
              if (willLogout) {
                self.$emit('logout')
                self.$swal("Merci de votre visite !", {
                  icon: "success",
                });
              } else {
                return;
              }
            });
        
        }
        }
        
    }
</script>

<style lang="css">
  #user_name{
    font-weight: bold;
    font-size: 17px;
    margin-right: 30px;
    color: white;
  }
</style>